import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = ({ contactInfo = {} }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const whatsappNumber = contactInfo.whatsapp_number || '919118946361';

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Hello Narain Trading Co.,\n\n" +
      "I would like to enquire about your products.\n\n" +
      "Project Details:\n" +
      "• Company/Firm Name: \n" +
      "• Role (Contractor / MEP Consultant / Builder): \n" +
      "• Project Location: \n" +
      "• Required Products: \n" +
      "• Approx Quantity: \n\n" +
      "Thank you."
    );
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap shadow-lg">
          Chat with us on WhatsApp
          <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900"></div>
        </div>
      )}
      <button
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all hover:scale-110 flex items-center justify-center group animate-bounce"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-floating-button"
      >
        <MessageCircle size={28} className="group-hover:rotate-12 transition-transform" />
      </button>
    </div>
  );
};

export default WhatsAppButton;
